import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { UnitSystem } from '@/interfaces/units';
import { ILccaCalculatedImperial, ILccaCalculatedMetric } from '@/modules/lcca/interfaces/lccaCalculated';
import { getLccaFromR23Report } from '@/modules/lcca/lib/r23ToSuiteTransformers';
import { exampleAsphaltDesignR23Report } from '@/lib/data/exampleR23Reports';
import { IProjectMetadata } from '@/interfaces/report';
import { testReportMetadata } from '@/lib/data/exampleReportMetadata';
import { $http } from '@/main';
import { AxiosResponse } from 'axios';
import { IPxError, processReason } from '@/lib/util/errors';
import { lccaImperialToMetric, lccaMetricToImperial } from '@/modules/lcca/lib/unitConversion/lccaScenario';
import { IBaseScenario } from '@/lib/types/IBaseScenario';
import { userStore } from '@/store/store';

// const defaultLccaImperial: ILccaCalculatedImperial =
// defaultLccaImperial.alternatives.forEach(A => console.log(A.index, A.name))

const endpoint = 'lcca';

@Module({
  name: 'lcca',
  namespaced: true,
})
export default class LccaStore extends VuexModule {
  /*
  A central location for http httpErrors to go
   */
  httpErrors: IPxError[] = [];

  @Mutation
  pushHttpErrors(reason: { response: AxiosResponse }) {
    this.httpErrors = processReason(reason);
  }

  @Mutation
  pushError(error: IPxError) {
    this.httpErrors.push(error);
  }

  @Mutation
  clearErrors() {
    this.httpErrors = [];
  }


  /*
  Unit system
   */

  displayUnits: UnitSystem = UnitSystem.Imperial;

  @Mutation
  setDisplayUnits(targetUnitSystem: UnitSystem) {
    console.log('Changing units to', targetUnitSystem);
    this.displayUnits = targetUnitSystem;
    if (this.currentImperial) {
      this.currentImperial.displayUnits = targetUnitSystem;
    }
  }

  /*
  LCCA Models
   */

  currentImperial: ILccaCalculatedImperial = getLccaFromR23Report(testReportMetadata, exampleAsphaltDesignR23Report, -1);// defaultLccaImperial;

  get currentMetric(): ILccaCalculatedMetric {
    console.log('Converting lcca to metric');
    return lccaImperialToMetric(this.currentImperial);
  }

  get currentScenario(): ILccaCalculatedImperial | ILccaCalculatedMetric {
    console.log('Fetching LCCA with units:', this.displayUnits);
    if (this.displayUnits === UnitSystem.Imperial) {
      return this.currentImperial;
    }
    return this.currentMetric;
  }

  // get currentImperial(): ILccaCalculatedImperial{
  //   return this.currentImperial
  // }

  currentProject: IProjectMetadata | null = null;

  @Mutation
  setCurrentProjectMetadata(project: IProjectMetadata) {
    this.currentProject = project;
  }

  @Mutation
  setCurrentScenario(lccaScenario: ILccaCalculatedImperial | ILccaCalculatedMetric) {
    console.debug('setting scenario', lccaScenario.displayUnits);
    if (lccaScenario.unitSystem === UnitSystem.Imperial) {
      console.debug('imperial');
      this.currentImperial = lccaScenario;
    } else if (lccaScenario.unitSystem === UnitSystem.Metric) {
      console.debug('metric');
      this.currentImperial = lccaMetricToImperial(lccaScenario);
    }
  }

  @Action({ rawError: true })
  saveNewScenario(scenario: ILccaCalculatedImperial) {
    scenario.displayUnits = this.displayUnits;
    return $http.post(`project/${endpoint}/new`, scenario).then((response) => response.data).catch((reason) => {
      this.pushHttpErrors(reason);
    });
  }

  @Action({ rawError: true })
  loadCurrentScenario(id: number) {
    console.log(`fetching ${endpoint}`, id);
    return $http.get(`project/${endpoint}/${id}`).then((response) => {
      this.setCurrentScenario(response.data);
      return response.data;
    }).catch((reason) => {
      this.pushHttpErrors(reason);
    });
  }

  @Action({ rawError: true })
  saveCurrentScenario() {
    this.currentImperial.displayUnits = this.displayUnits;
    // console.log(`saving ${endpoint}  to db`, this.currentImperial.id, this.currentImperial.displayUnits, this.currentImperial);
    $http.put(`project/${endpoint}/${this.currentImperial.id}`, this.currentImperial).then(
      (response) => {
        this.setCurrentScenario(response.data);
        console.log('units', response.data.displayUnits);
      },
    ).catch((reason) => {
      this.pushHttpErrors(reason);
    });
  }

  @Action
  deleteScenario(scenario: IBaseScenario) {
    return $http.delete(`/project/lcca/${scenario.id}`).catch((reason) => this.pushHttpErrors(reason));
  }
}
